import React, { useRef, useState } from 'react';
import Alert from '@uber/base-icons/alert';
import { styled } from 'baseui';
import { useSnackbar } from 'baseui/snackbar';
import { LABEL_COLOR_PICKER_ID } from '../../../common/side-panel/constants';
import { LABEL_COLOR_MODIFICATION_ERROR, LONG_TOAST_DURATION } from '../const';
type PropsT = {
  handleLabelColorChange: (colorPickerPayload: {
    color: string;
    title: string;
  }) => boolean;
  renderIcon: (props: {
    strokeColor: string;
  }) => React.ReactNode;
  color: string;
  title: string;
};
const HiddenColorPicker = styled('input', {
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
  width: '1px',
  height: '1px',
  zIndex: 1000
});
const DisplayIconWrapper = styled('label', {
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative'
});
const colorPickerProps = {
  'data-testid': 'color-picker',
  'data-selector-id': LABEL_COLOR_PICKER_ID
};
const LabelColorPicker = ({
  handleLabelColorChange,
  renderIcon,
  color,
  title
}: PropsT) => {
  const colorPickerRef = useRef<HTMLInputElement>(null);
  const {
    enqueue
  } = useSnackbar();
  const labelIndex = title.includes('_') ? -1 : 0; // this is to restrict user to switch colors for instance segmentation labels
  const [colorValue, setColorValue] = useState(color);
  const colorPickerPayload = {
    color: colorValue,
    title
  };
  return <>
      <DisplayIconWrapper htmlFor={title} onClick={e => {
      e.stopPropagation();
      if (labelIndex === -1) {
        enqueue({
          message: LABEL_COLOR_MODIFICATION_ERROR,
          startEnhancer: () => <Alert title="Error" />
        }, LONG_TOAST_DURATION);
      }
    }} key={title}>
        {renderIcon({
        strokeColor: colorValue
      })}
        {labelIndex !== -1 ? <HiddenColorPicker id={title} ref={colorPickerRef} type="color" value={colorValue} onChange={e => {
        setColorValue(e.target.value);
      }} onBlur={() => {
        const isColorChanged = handleLabelColorChange(colorPickerPayload);
        if (!isColorChanged) {
          setColorValue(color);
        }
      }} {...colorPickerProps} /> : null}
      </DisplayIconWrapper>
    </>;
};
export default LabelColorPicker;